import * as React from 'react'
import {useSelector} from 'react-redux'
import {selectTicketNumber} from './selectors'
import Button from 'airship/patterns/button'

interface ThankYouProps {
  handleClose: () => void
}
const ThankYou: React.FC<ThankYouProps> = ({handleClose}) => {
  const ticketNumber = useSelector(selectTicketNumber)

  return (
    <>
      <h1 className="u-space-bottom-1">Thank you for contacting support</h1>
      <div className="u-space-bottom-1">
        <p>
          A support team member will review your request and reply on your
          support ticket soon.
        </p>
      </div>
      <p>
        Your support ticket is{' '}
        <a
          className="u-blue"
          href={`https://support.airship.com/hc/requests/${ticketNumber}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          #{ticketNumber}
        </a>
        , and you&apos;ll be contacted by email.
      </p>
      <a
        className="u-space-bottom-2 u-blue"
        href="https://www.airship.com/legal/support-services/"
        target="_blank"
        rel="noopener noreferrer"
      >
        When will I be contacted?
      </a>

      <div className="u-flex u-flex-justify-end">
        <Button onClick={handleClose} style="navy">
          Close
        </Button>
      </div>
    </>
  )
}

export default ThankYou
